module.exports = __webpack_public_path__ + "img/icon.4cdf2628.svg";